import { ApiClient } from "@/api-client/src/core/api-client";
import { MenuResponse } from "@/packages/types/menu";

const apiClient = new ApiClient();
const webService = apiClient.web;

/**
 * Fetch list of categories
 * @param page default is 1
 * @param limit default is 10
 */
export const fetchHeaderMenu = async (): Promise<MenuResponse> => {
  const response = await webService.get<MenuResponse>(`/mega-menu`);
  return response;
};
